import { render } from "./stock-employee-detail.vue?vue&type=template&id=0855a3c8"
import script from "./stock-employee-detail.vue?vue&type=script&lang=js"
export * from "./stock-employee-detail.vue?vue&type=script&lang=js"

import "./stock-employee-detail.vue?vue&type=style&index=0&id=0855a3c8&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__